import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Profile, User, UserService } from "../../../shared";

@Component({
  selector: "app-user-profile",
  templateUrl: "./profile.component.html",
  styleUrls: [
    "./profile.component.scss",
    "../../../../assets/icon/icofont/css/icofont.scss",
  ],
})
export class ProfileComponent implements OnInit {
  public currentUser: User;
  public ownsProfile: boolean = false;
  public profile: Profile;
  constructor(
    private route: ActivatedRoute,
    private userService: UserService
  ) {}

  ngOnInit() {
    this.route.data.subscribe((data: { profile: Profile }) => {
      this.profile = data.profile;

      this.userService.currentUser.subscribe((userData: User) => {
        this.currentUser = userData;
        this.ownsProfile = userData.username === data.profile.username;
      });
    });
  }

  public onToggleFollowing(following: boolean) {
    this.profile.isFollowing.following = following;
  }
}
